import { Injectable } from '@angular/core';
import { Mutation, gql } from 'apollo-angular';

export interface InsertAccountBillingProfileResponse {
  createAccountBillingProfiles: {
    code: string;
    success: boolean;
    message: string;
    accountBillingProfiles: {
      uid: string;
      account_id: number;
      import_profile_id: number;
      ftp_user: string;
      dir: string;
      primary: boolean;
      profileName: string;
      profileUid: string;
    };
  };
}

export interface InsertAccountBillingProfileInput {
  accountUid: string;
  profileUid: string;
  ftpUser: string;
  type: string;
  dir: string;
}

@Injectable({
  providedIn: 'root',
})
export class InsertAccountBillingProfileGQL extends Mutation<
  InsertAccountBillingProfileResponse,
  InsertAccountBillingProfileInput
> {
  document = gql(`
    mutation insertAccountBillingProfile($accountUid: String!, $profileUid: String!, $ftpUser: String!, $type: String!, $dir: String!) {
      insertAccountBillingProfile(accountUid: $accountUid, profileUid: $profileUid, ftpUser: $ftpUser, type: $type, dir: $dir) {
        code
        success
        message
      }
    }
  `);
}

export interface UpdateAccountBillingProfileResponse {
  updateAccountBillingProfiles: {
    code: string;
    success: boolean;
    message: string;
  };
}

export interface UpdateAccountBillingProfileInput {
  uid: string;
  profileUid: string;
}

@Injectable({
  providedIn: 'root',
})
export class UpdateAccountBillingProfileGQL extends Mutation<
  UpdateAccountBillingProfileResponse,
  UpdateAccountBillingProfileInput
> {
  document = gql(`
    mutation updateAccountBillingProfile($uid: String!, $profileUid: String!) {
      updateAccountBillingProfile(uid: $uid, profileUid: $profileUid) {
        code
        success
        message
      }
    }
  `);
}

export interface DeleteAccountBillingProfileResponse {
  deleteAccountBillingProfile: {
    code: string;
    success: boolean;
    message: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class DeleteAccountBillingProfileGQL extends Mutation<DeleteAccountBillingProfileResponse, { uid: string }> {
  document = gql(`
    mutation deleteAccountBillingProfile($uid: String!) {
      deleteAccountBillingProfile(uid: $uid) {
        code
        success
        message
      }
    }
  `);
}
